(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');

  function initTabShowcase(section) {
    var tabs = section.querySelectorAll('.mt-tab-showcase__tab');
    var panels = section.querySelectorAll('.mt-tab-showcase__panel');
    var prevBtn = section.querySelector('[data-tab-prev]');
    var nextBtn = section.querySelector('[data-tab-next]');
    var panelsWrap = section.querySelector('[data-tab-panels]');

    if (!tabs.length || !panels.length) return;

    var count = tabs.length;
    var currentIndex = 0;
    var touchStartX = 0;
    var touchStartY = 0;

    tabs.forEach(function (tab, i) {
      if (tab.classList.contains('is-active')) {
        currentIndex = i;
      }
    });

    function setActive(index) {
      currentIndex = ((index % count) + count) % count;

      tabs.forEach(function (tab, i) {
        var isActive = i === currentIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === currentIndex;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setActive(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        setActive(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        setActive(currentIndex + 1);
      });
    }

    if (panelsWrap) {
      panelsWrap.addEventListener(
        'touchstart',
        function (e) {
          if (!MOBILE_MQ.matches || e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        },
        { passive: true }
      );

      panelsWrap.addEventListener(
        'touchend',
        function (e) {
          if (!MOBILE_MQ.matches || e.changedTouches.length !== 1) return;

          var touchEndX = e.changedTouches[0].clientX;
          var touchEndY = e.changedTouches[0].clientY;
          var diffX = touchEndX - touchStartX;
          var diffY = touchEndY - touchStartY;

          if (Math.abs(diffX) < 40 || Math.abs(diffX) < Math.abs(diffY)) return;

          if (diffX < 0) {
            setActive(currentIndex + 1);
          } else {
            setActive(currentIndex - 1);
          }
        },
        { passive: true }
      );
    }
  }

  function initAll() {
    document.querySelectorAll('.mt-tab-showcase[data-section-id]').forEach(initTabShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.mt-tab-showcase[data-section-id]');
    if (section) initTabShowcase(section);
  });
})();
